<app-modal-container i18n-title title="Er du sikker på du ønsker at fjerne denne vare fra din kurv?">
  <div class="d-flex">
    <button (click)="activeModal.close(false)" class="btn btn-outline-primary mx-2 flex-grow-1" i18n>Behold</button>
    <button (click)="activeModal.close(true)" class="btn btn-primary mx-2 flex-grow-1" i18n>Fjern</button>
  </div>
</app-modal-container>
